<template>
    <div>
     <navbar :title="fad" :box="box"/>
  <div class="tree" style="margin-top:15px">
    <!-- <input class="tree-search-input" type="text" v-model.lazy="searchword" placeholder="search..."/> 
    <button class=" tree-search-btn" type="button" @click="search">GO</button>-->
    <v-tree ref='tree' :data='treeData' :halfcheck='true' />
  </div>
  <!-- <Tree :value="treeData" edgeScroll style="width:400px;">
    <span slot-scope="{node, path}">
      <b @click="tree.toggleFold(node, path)">
        {{node.$folded ? '+' : '-'}}
      </b>
      {{node.text}}
    </span>
  </Tree> -->

      <van-popup v-model="show"><van-loading type="spinner" color="#fff" /></van-popup>
    </div>
</template>

<script>
import {helper} from '@/helper';
import { userService } from '@/plugins/_services';
import navbar from './nav'
import {Toast} from 'vant'
// import 'he-tree-vue/dist/he-tree-vue.css'
// import {Tree,Fold} from 'he-tree-vue'
export default {
components:{
  navbar
  // ,Tree: Tree.mixPlugins([Fold])
},
  data() {
    return {
      currentRate:0,
      treeData:[],
      searchword: '',
      initSelected: ['node-1'],
      show:false,
      fad:this.$route.params.ad,
      ref_kod:helper.settings.ayar().referans,
      uye_kod:this.$route.params.kod,
      uye_ad:helper.settings.ayar().uye_ad,
      parola:helper.settings.ayar().pass,
      box:JSON.parse(localStorage.getItem('ayuBox')).baskets.length || 0,
      obje:[],
      obje2:[],
      derinlik:0,
      anakol:0,
      toplamuye:0,
    };
  },
  computed: {
    
  }, 
created (){
    this.show = true
    userService.handleResponse(helper.settings.ayar().username,helper.settings.ayar().pass)
    .then(res => {
      this.liste()
      })
    .catch(err => {userService.logout()})
},
methods:{

overrideSlotDefault({node, index, path, tree}, original) {
      return ` <div class="node-content">
        <button class="mrs drag-trigger">Drag</button>
        <button class="mrs fold-btn" onClick={() => tree.toggleFold(node, path)}>{node.$folded ? '+' : '-'}</button>
        {original()}
        <button class="mls">edit</button>
        <button class="mls" onClick={() => this.removeNodeByPath(path)}>remove</button>
        <button class="mls" onClick={() => this.hideNode(node)}>hidden</button>
      </div>`
    },


    tpl (...args) {
      let {0: node, 2: parent, 3: index} = args
      let titleClass = node.selected ? 'node-title node-selected' : 'node-title'
      if (node.searched) titleClass += ' node-searched'
      return `<span>
        <button class="treebtn1" onClick={() => this.$refs.tree.addNode(node, {title: 'sync node'})}>+</button>
         <span class={titleClass} domPropsInnerHTML={node.title} onClick={() => {
           this.$refs.tree.nodeSelected(node)
         }}></span>
      <button class="treebtn2" onClick={() => this.asyncLoad(node)}>async</button>
      <button class="treebtn3" onClick={() => this.$refs.tree.delNode(node, parent, index)}>delete</button>
      </span>`
    },
    async asyncLoad (node) {
      this.$set(node, 'loading', true)
      let pro = new Promise(resolve => {
        setTimeout(resolve, 2000, ['async node1', 'async node2'])
      })
      this.$refs.tree1.addNodes(node, await pro)
      this.$set(node, 'loading', false)
    },
    search () {
      this.$refs.tree.searchNodes(this.searchword)
    },


// treview  
liste(){
  helper.request.get("org2/"+this.uye_kod) .then(res => { 
    if (res.results.length === 0 ) this.show = false
    else{
      this.hobbala(res.results,this.aay,this.ayil,0,this.uye_kod)
    }
    })
},



    hobbala(arg,ay,yil,anakol,anakod){
      var pross = 0
      for (let i = 0, p = Promise.resolve(); i < arg.length; i++) {
        p = p.then(_ => new Promise(resolve => {
                    anakol++
          this.derinlik = 1
          let data = {
          kod:arg[i].uye_kod,
          derinlik : this.derinlik,
          anakol:anakol,
          ad:arg[i].uye_ad,
          sponsor:'ana'
          }
          this.obje.push(data)
          this.kol(data.kod,data.derinlik,anakol)
            .then(res => {
              pross++
              if(arg.length === pross){
                //console.log(this.obje)
               // console.log(this.obje)
              setTimeout(() => {
                const tree = this.grupla(this.obje);
                //console.log(tree);
                 this.treeData = tree
                 this.show = false
                }, 2000);
                
              }
              resolve()
            })
           }
        ))
      }
    },
    kol(kod,derinlik,anakol){
      return new Promise ((resolve,reject)=>{
        helper.request.get("org2/"+kod)
        .then(res => {
          if (res.results.length===0){resolve(true)}
           else{
             derinlik++
              this.getProduct(res.results,derinlik,anakol)
               .then(res=>{
                 this.getProduct2().then(response => {
                   //setTimeout(() => {
                     resolve()
                   //},1000 );
                   
                 })
             })
            }
        })
      })
    },
    getProduct2(){
      return new Promise ((resolve,reject)=>{
        var pros = 0
        this.obje2.forEach((element) => { 
            this.kol(element.kod,element.derinlik,element.anakol)
            pros++
        });
        if (pros === this.obje2.length) resolve()
      })
    },
    getProduct(arg,derinlik,anakol){ // sabit arttıcı
    return new Promise ((resolve,reject)=>{
    this.obje2 = []
      var pros = 0
      var sayac = 0
          arg.forEach((element,i) => {
            sayac++
              let data = {
                 kod:element.uye_kod,
                 derinlik : derinlik,
                 anakol:anakol,
                 ad:element.uye_ad,
                 sponsor:element.ref_kod
               }
          this.obje.push(data)
          this.obje2.push(data)
          pros++
          });

        //  },500);
          if(arg.length === pros){
            resolve(true)
          }
      })
    },
    grupla(arr){
        return arr
    // first restructure existing nodes as a tree
    .reduce((result, value, index, originalArray) => {
      if (value.sponsor !== 'ana') {
        const parent = this.findParent(originalArray, value.sponsor);

        if (parent) {
          // add as child if has parent
          parent.children = (parent.children || []).concat(value);
        }

        return result;
      } else {
        // Add value to top level of the result array
        return result.concat(value);
      }
    }, [] /* Initialize with empty result array */)
    // them map to new data type
    .map(this.createTreeNode);

        
    },
    findParent(arr, kod) {
  return arr.find((parent) => parent.kod === kod);
    },
    createTreeNode(value) {
  return {
    title: value.ad+' '+value.kod,
    //path: ,
    children: (value.children !== undefined)
      ? value.children.map(this.createTreeNode)
      : undefined
  };
    }

}
};
</script>
<style>
van-circle{background:white}
</style>


// WEBPACK FOOTER //
// src/components/detay.vue